// @flow
import type { DataLoaderParams } from '../../../types/DataLoaderParams';
import { fetchAllBidderBiddingIfNeeded } from '../../../redux/modules/bidderBiddingInfoAll';
import { recordAnalyticsForMyBidsPageView } from '../../../redux/modules/analytics';

export default ({ store }: DataLoaderParams) => {
    const { dispatch } = store;
    return Promise.all([dispatch(fetchAllBidderBiddingIfNeeded())]).then(() => {
        return Promise.all([dispatch(recordAnalyticsForMyBidsPageView())]);
    });
};
